import React from 'react'

const SvgExclamationDefault = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12.5 14V5c0-.667.333-1 1-1s1 .333 1 1v9c0 .666-.332 1-.997 1s-1-.333-1.003-1zm1 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z' />
  </svg>
)

export default SvgExclamationDefault
